import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppAccordionItem, LazyAppAlertBox, LazyAppBreadcrumbs, LazyAppComponentRenderer, LazyAppCookieConsent, LazyAppFilterPopup, LazyAppFooter, LazyAppIcon, LazyAppLightBox, LazyAppMap, LazyAppHeader, LazyAppHeaderQuickShop, LazyAppNavList, LazyAppNavListItem, LazyAppNavListItemMobile, LazyAppNavListMobile, LazyAppNavMegaFlyout, LazyAppNavMegaFlyoutContent, LazyAppNavMegaFlyoutMobile, LazyAppNavMegaFlyoutSidebar, LazyAtomAddressBlock, LazyAtomButton, LazyAtomCartIcon, LazyAtomClickAndCollectNotice, LazyAtomCta, LazyAtomDivider, LazyAtomDownloadButton, LazyAtomFlag, LazyAtomHeading, LazyAtomImage, LazyAtomImage360, LazyAtomImageLabel, LazyAtomImageSwitch, LazyAtomLead, LazyAtomLoadMore, LazyAtomMap, LazyAtomRichtext, LazyAtomSubnavAnchor, LazyAtomSubnavLink, LazyAtomTab, LazyAtomTabControls, LazyAtomVideo, LazyAuthBillingAddress, LazyAuthBookmarks, LazyAuthCompleteRegistration, LazyAuthDelete, LazyAuthDeliveryAddress, LazyAuthForgotPassword, LazyAuthLogin, LazyAuthLoginCheckout, LazyAuthNewsletter, LazyAuthRegistration, LazyAuthResetPassword, LazyAuthUpdataUserPassword, LazyAuthUpdataUserdata, LazyAuthUpdatePharmacy, LazyBlockAccordion, LazyBlockAccordionElement, LazyBlockAuthor, LazyBlockBannerBlog, LazyBlockBannerCta, LazyBlockBlogCurated, LazyBlockBlogExpert, LazyBlockBrandsList, LazyBlockBrandsListItem, LazyBlockButtonNavigation, LazyBlockCompendium, LazyBlockContactCard, LazyBlockContactForm, LazyBlockDetailBlog, LazyBlockEventSubscription, LazyBlockFolderLinks, LazyBlockHero, LazyBlockHeroBlog, LazyBlockHeroConsultations, LazyBlockHeroEvents, LazyBlockHeroProducts, LazyBlockHighlightProduct, LazyBlockImageCaption, LazyBlockIndications, LazyBlockIndicationsItemBackup, LazyBlockIndicationsItem, LazyBlockInfoBlog, LazyBlockInfoPharmacy, LazyBlockInformationCards, LazyBlockJobsList, LazyBlockLinkBox, LazyBlockMedicosearch, LazyBlockProductsFlyout, LazyBlockProductsFlyoutItem, LazyBlockQuote, LazyBlockSliderHero, LazyBlockSliderHeroSlide, LazyBlockSocialShare, LazyBlockStepLinks, LazyBlockSubnav, LazyBlockSubnavAnchor, LazyBlockSubnavLink, LazyBlockTabs, LazyBlockTabsController, LazyBlockTeaserBlog, LazyBlockTeaserBlogCard, LazyBlockTeaserBlogDossier, LazyBlockTeaserCuratedBlog, LazyBlockTeaserCuratedDossier, LazyBlockHeroLandingpage, LazyFilterAdvanced, LazyFilterBlogs, LazyFilterMain, LazyFilterSecondary, LazyFilterSwitch, LazyFilterTags, LazyFilterText, LazyFormConfirmation, LazyFormController, LazyFormFieldErrors, LazyFormInputCheckbox, LazyFormInputDate, LazyFormInputDateTime, LazyFormInputEmail, LazyFormInputNumber, LazyFormInputPassword, LazyFormInputSelectField, LazyFormInputText, LazyFormInputTextarea, LazyFormLink, LazyFormMessage, LazyShopCartList, LazyShopCartListDiscount, LazyShopCartListEntry, LazyShopCart, LazyShopCartDiscount, LazyShopCartPopup, LazyShopCartShipping, LazyShopCheckoutAddress, LazyShopCheckoutAddressFormItem, LazyShopCheckoutAddressForms, LazyShopCheckoutPharmacy, LazyShopCheckoutShipping, LazyShopOrder, LazyShopOrderItem, LazyShopOrderItemAmount, LazyShopProductCard, LazyShopProductCardContent, LazyShopProductCardDiscount, LazyShopProductCardImage, LazyShopProductCardLocation, LazyShopProductCardPrice, LazyShopProductCardSpeaker, LazyShopProductAvailabilityPopup, LazyShopProductControls, LazyShopProductDeliveryPopup, LazyShopProductRelatedProducts, LazyShopProductRenderer, LazyShopProductSlider, LazyShopProductStatic, LazyShopProducts, LazyShopProductsCombined, LazyShopProductsCurated, LazyShopProductsMix, LazyShopProductsMixBackup, LazyShopProductsNew, LazyShopBundleSpotlight, LazyShopPastOrders, LazyShopSearchHero, LazySlotLink, LazySlotProductFrame, LazyStorybookExample, LazySvgoAdd, LazySvgoAlertError, LazySvgoAlertSuccess, LazySvgoArrowDown, LazySvgoArrowLeft, LazySvgoArrowRight, LazySvgoArrowUp, LazySvgoBell, LazySvgoBookmarkRemove, LazySvgoBookmark, LazySvgoBoxes, LazySvgoBurger, LazySvgoCalendarEvents, LazySvgoCalendar, LazySvgoCartSmall, LazySvgoCart, LazySvgoCheckmarkRound, LazySvgoClickNCollectFlag, LazySvgoClickNCollect, LazySvgoClock, LazySvgoCloseBackground, LazySvgoCloseBox, LazySvgoClose, LazySvgoComputer, LazySvgoDeselect, LazySvgoDiscount, LazySvgoFacebook, LazySvgoHelped, LazySvgoHome, LazySvgoIconDown, LazySvgoIconRight, LazySvgoIconUp, LazySvgoInfant, LazySvgoInfo, LazySvgoInstagram, LazySvgoList, LazySvgoLogout, LazySvgoLoved, LazySvgoPassword, LazySvgoPlay, LazySvgoPregnant, LazySvgoProductPlaceholder, LazySvgoSanerlogo, LazySvgoSave, LazySvgoSearch, LazySvgoSliderArrow, LazySvgoSnake, LazySvgoTicket, LazySvgoTiktok, LazySvgoTipp, LazySvgoTrashBin, LazySvgoTruck, LazySvgoTwitter, LazySvgoUser, LazySvgoVegan, LazySvgoWizard } from '#components'
const lazyGlobalComponents = [
  ["AppAccordionItem", LazyAppAccordionItem],
["AppAlertBox", LazyAppAlertBox],
["AppBreadcrumbs", LazyAppBreadcrumbs],
["AppComponentRenderer", LazyAppComponentRenderer],
["AppCookieConsent", LazyAppCookieConsent],
["AppFilterPopup", LazyAppFilterPopup],
["AppFooter", LazyAppFooter],
["AppIcon", LazyAppIcon],
["AppLightBox", LazyAppLightBox],
["AppMap", LazyAppMap],
["AppHeader", LazyAppHeader],
["AppHeaderQuickShop", LazyAppHeaderQuickShop],
["AppNavList", LazyAppNavList],
["AppNavListItem", LazyAppNavListItem],
["AppNavListItemMobile", LazyAppNavListItemMobile],
["AppNavListMobile", LazyAppNavListMobile],
["AppNavMegaFlyout", LazyAppNavMegaFlyout],
["AppNavMegaFlyoutContent", LazyAppNavMegaFlyoutContent],
["AppNavMegaFlyoutMobile", LazyAppNavMegaFlyoutMobile],
["AppNavMegaFlyoutSidebar", LazyAppNavMegaFlyoutSidebar],
["AtomAddressBlock", LazyAtomAddressBlock],
["AtomButton", LazyAtomButton],
["AtomCartIcon", LazyAtomCartIcon],
["AtomClickAndCollectNotice", LazyAtomClickAndCollectNotice],
["AtomCta", LazyAtomCta],
["AtomDivider", LazyAtomDivider],
["AtomDownloadButton", LazyAtomDownloadButton],
["AtomFlag", LazyAtomFlag],
["AtomHeading", LazyAtomHeading],
["AtomImage", LazyAtomImage],
["AtomImage360", LazyAtomImage360],
["AtomImageLabel", LazyAtomImageLabel],
["AtomImageSwitch", LazyAtomImageSwitch],
["AtomLead", LazyAtomLead],
["AtomLoadMore", LazyAtomLoadMore],
["AtomMap", LazyAtomMap],
["AtomRichtext", LazyAtomRichtext],
["AtomSubnavAnchor", LazyAtomSubnavAnchor],
["AtomSubnavLink", LazyAtomSubnavLink],
["AtomTab", LazyAtomTab],
["AtomTabControls", LazyAtomTabControls],
["AtomVideo", LazyAtomVideo],
["AuthBillingAddress", LazyAuthBillingAddress],
["AuthBookmarks", LazyAuthBookmarks],
["AuthCompleteRegistration", LazyAuthCompleteRegistration],
["AuthDelete", LazyAuthDelete],
["AuthDeliveryAddress", LazyAuthDeliveryAddress],
["AuthForgotPassword", LazyAuthForgotPassword],
["AuthLogin", LazyAuthLogin],
["AuthLoginCheckout", LazyAuthLoginCheckout],
["AuthNewsletter", LazyAuthNewsletter],
["AuthRegistration", LazyAuthRegistration],
["AuthResetPassword", LazyAuthResetPassword],
["AuthUpdataUserPassword", LazyAuthUpdataUserPassword],
["AuthUpdataUserdata", LazyAuthUpdataUserdata],
["AuthUpdatePharmacy", LazyAuthUpdatePharmacy],
["BlockAccordion", LazyBlockAccordion],
["BlockAccordionElement", LazyBlockAccordionElement],
["BlockAuthor", LazyBlockAuthor],
["BlockBannerBlog", LazyBlockBannerBlog],
["BlockBannerCta", LazyBlockBannerCta],
["BlockBlogCurated", LazyBlockBlogCurated],
["BlockBlogExpert", LazyBlockBlogExpert],
["BlockBrandsList", LazyBlockBrandsList],
["BlockBrandsListItem", LazyBlockBrandsListItem],
["BlockButtonNavigation", LazyBlockButtonNavigation],
["BlockCompendium", LazyBlockCompendium],
["BlockContactCard", LazyBlockContactCard],
["BlockContactForm", LazyBlockContactForm],
["BlockDetailBlog", LazyBlockDetailBlog],
["BlockEventSubscription", LazyBlockEventSubscription],
["BlockFolderLinks", LazyBlockFolderLinks],
["BlockHero", LazyBlockHero],
["BlockHeroBlog", LazyBlockHeroBlog],
["BlockHeroConsultations", LazyBlockHeroConsultations],
["BlockHeroEvents", LazyBlockHeroEvents],
["BlockHeroProducts", LazyBlockHeroProducts],
["BlockHighlightProduct", LazyBlockHighlightProduct],
["BlockImageCaption", LazyBlockImageCaption],
["BlockIndications", LazyBlockIndications],
["BlockIndicationsItemBackup", LazyBlockIndicationsItemBackup],
["BlockIndicationsItem", LazyBlockIndicationsItem],
["BlockInfoBlog", LazyBlockInfoBlog],
["BlockInfoPharmacy", LazyBlockInfoPharmacy],
["BlockInformationCards", LazyBlockInformationCards],
["BlockJobsList", LazyBlockJobsList],
["BlockLinkBox", LazyBlockLinkBox],
["BlockMedicosearch", LazyBlockMedicosearch],
["BlockProductsFlyout", LazyBlockProductsFlyout],
["BlockProductsFlyoutItem", LazyBlockProductsFlyoutItem],
["BlockQuote", LazyBlockQuote],
["BlockSliderHero", LazyBlockSliderHero],
["BlockSliderHeroSlide", LazyBlockSliderHeroSlide],
["BlockSocialShare", LazyBlockSocialShare],
["BlockStepLinks", LazyBlockStepLinks],
["BlockSubnav", LazyBlockSubnav],
["BlockSubnavAnchor", LazyBlockSubnavAnchor],
["BlockSubnavLink", LazyBlockSubnavLink],
["BlockTabs", LazyBlockTabs],
["BlockTabsController", LazyBlockTabsController],
["BlockTeaserBlog", LazyBlockTeaserBlog],
["BlockTeaserBlogCard", LazyBlockTeaserBlogCard],
["BlockTeaserBlogDossier", LazyBlockTeaserBlogDossier],
["BlockTeaserCuratedBlog", LazyBlockTeaserCuratedBlog],
["BlockTeaserCuratedDossier", LazyBlockTeaserCuratedDossier],
["BlockHeroLandingpage", LazyBlockHeroLandingpage],
["FilterAdvanced", LazyFilterAdvanced],
["FilterBlogs", LazyFilterBlogs],
["FilterMain", LazyFilterMain],
["FilterSecondary", LazyFilterSecondary],
["FilterSwitch", LazyFilterSwitch],
["FilterTags", LazyFilterTags],
["FilterText", LazyFilterText],
["FormConfirmation", LazyFormConfirmation],
["FormController", LazyFormController],
["FormFieldErrors", LazyFormFieldErrors],
["FormInputCheckbox", LazyFormInputCheckbox],
["FormInputDate", LazyFormInputDate],
["FormInputDateTime", LazyFormInputDateTime],
["FormInputEmail", LazyFormInputEmail],
["FormInputNumber", LazyFormInputNumber],
["FormInputPassword", LazyFormInputPassword],
["FormInputSelectField", LazyFormInputSelectField],
["FormInputText", LazyFormInputText],
["FormInputTextarea", LazyFormInputTextarea],
["FormLink", LazyFormLink],
["FormMessage", LazyFormMessage],
["ShopCartList", LazyShopCartList],
["ShopCartListDiscount", LazyShopCartListDiscount],
["ShopCartListEntry", LazyShopCartListEntry],
["ShopCart", LazyShopCart],
["ShopCartDiscount", LazyShopCartDiscount],
["ShopCartPopup", LazyShopCartPopup],
["ShopCartShipping", LazyShopCartShipping],
["ShopCheckoutAddress", LazyShopCheckoutAddress],
["ShopCheckoutAddressFormItem", LazyShopCheckoutAddressFormItem],
["ShopCheckoutAddressForms", LazyShopCheckoutAddressForms],
["ShopCheckoutPharmacy", LazyShopCheckoutPharmacy],
["ShopCheckoutShipping", LazyShopCheckoutShipping],
["ShopOrder", LazyShopOrder],
["ShopOrderItem", LazyShopOrderItem],
["ShopOrderItemAmount", LazyShopOrderItemAmount],
["ShopProductCard", LazyShopProductCard],
["ShopProductCardContent", LazyShopProductCardContent],
["ShopProductCardDiscount", LazyShopProductCardDiscount],
["ShopProductCardImage", LazyShopProductCardImage],
["ShopProductCardLocation", LazyShopProductCardLocation],
["ShopProductCardPrice", LazyShopProductCardPrice],
["ShopProductCardSpeaker", LazyShopProductCardSpeaker],
["ShopProductAvailabilityPopup", LazyShopProductAvailabilityPopup],
["ShopProductControls", LazyShopProductControls],
["ShopProductDeliveryPopup", LazyShopProductDeliveryPopup],
["ShopProductRelatedProducts", LazyShopProductRelatedProducts],
["ShopProductRenderer", LazyShopProductRenderer],
["ShopProductSlider", LazyShopProductSlider],
["ShopProductStatic", LazyShopProductStatic],
["ShopProducts", LazyShopProducts],
["ShopProductsCombined", LazyShopProductsCombined],
["ShopProductsCurated", LazyShopProductsCurated],
["ShopProductsMix", LazyShopProductsMix],
["ShopProductsMixBackup", LazyShopProductsMixBackup],
["ShopProductsNew", LazyShopProductsNew],
["ShopBundleSpotlight", LazyShopBundleSpotlight],
["ShopPastOrders", LazyShopPastOrders],
["ShopSearchHero", LazyShopSearchHero],
["SlotLink", LazySlotLink],
["SlotProductFrame", LazySlotProductFrame],
["StorybookExample", LazyStorybookExample],
["SvgoAdd", LazySvgoAdd],
["SvgoAlertError", LazySvgoAlertError],
["SvgoAlertSuccess", LazySvgoAlertSuccess],
["SvgoArrowDown", LazySvgoArrowDown],
["SvgoArrowLeft", LazySvgoArrowLeft],
["SvgoArrowRight", LazySvgoArrowRight],
["SvgoArrowUp", LazySvgoArrowUp],
["SvgoBell", LazySvgoBell],
["SvgoBookmarkRemove", LazySvgoBookmarkRemove],
["SvgoBookmark", LazySvgoBookmark],
["SvgoBoxes", LazySvgoBoxes],
["SvgoBurger", LazySvgoBurger],
["SvgoCalendarEvents", LazySvgoCalendarEvents],
["SvgoCalendar", LazySvgoCalendar],
["SvgoCartSmall", LazySvgoCartSmall],
["SvgoCart", LazySvgoCart],
["SvgoCheckmarkRound", LazySvgoCheckmarkRound],
["SvgoClickNCollectFlag", LazySvgoClickNCollectFlag],
["SvgoClickNCollect", LazySvgoClickNCollect],
["SvgoClock", LazySvgoClock],
["SvgoCloseBackground", LazySvgoCloseBackground],
["SvgoCloseBox", LazySvgoCloseBox],
["SvgoClose", LazySvgoClose],
["SvgoComputer", LazySvgoComputer],
["SvgoDeselect", LazySvgoDeselect],
["SvgoDiscount", LazySvgoDiscount],
["SvgoFacebook", LazySvgoFacebook],
["SvgoHelped", LazySvgoHelped],
["SvgoHome", LazySvgoHome],
["SvgoIconDown", LazySvgoIconDown],
["SvgoIconRight", LazySvgoIconRight],
["SvgoIconUp", LazySvgoIconUp],
["SvgoInfant", LazySvgoInfant],
["SvgoInfo", LazySvgoInfo],
["SvgoInstagram", LazySvgoInstagram],
["SvgoList", LazySvgoList],
["SvgoLogout", LazySvgoLogout],
["SvgoLoved", LazySvgoLoved],
["SvgoPassword", LazySvgoPassword],
["SvgoPlay", LazySvgoPlay],
["SvgoPregnant", LazySvgoPregnant],
["SvgoProductPlaceholder", LazySvgoProductPlaceholder],
["SvgoSanerlogo", LazySvgoSanerlogo],
["SvgoSave", LazySvgoSave],
["SvgoSearch", LazySvgoSearch],
["SvgoSliderArrow", LazySvgoSliderArrow],
["SvgoSnake", LazySvgoSnake],
["SvgoTicket", LazySvgoTicket],
["SvgoTiktok", LazySvgoTiktok],
["SvgoTipp", LazySvgoTipp],
["SvgoTrashBin", LazySvgoTrashBin],
["SvgoTruck", LazySvgoTruck],
["SvgoTwitter", LazySvgoTwitter],
["SvgoUser", LazySvgoUser],
["SvgoVegan", LazySvgoVegan],
["SvgoWizard", LazySvgoWizard],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
